<template>
  <div class="commonInput" v-if="visible">
    <div class="commonInput-inner">
      <div class="commonInput-inner_title">信息提示</div>
      <div class="commonInput-inner_content">{{ text }}</div>
      <div class="commonInput-inner_btn">
        <a

          href="javascript:void(0)"
          class="commonInput-inner_btn_item"
          :style="{ backgroundColor: confirmColor }"
          @click="confirmFn"
          >{{ confirmText }}</a
        >
        <a
          v-if="cancel"
          href="javascript:void(0)"
          class="commonInput-inner_btn_item"
          :style="{ backgroundColor: cancelColor }"
          @click="cancelFn"
          >{{ cancelText }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    confirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    confirmColor: {
      type: String,
      default: '#42aef9'
    },
    cancel: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    cancelColor: {
      type: String,
      default: '#fb7a19'
    }
  },
  methods: {
    confirmFn() {
      this.$emit('confirmClick');
      this.$emit('update:visible', false);
    },
    cancelFn() {
      this.$emit('cancelClick');
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.commonInput {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  &-inner {
    width: 500px;
    border: 2px solid #1d7ecc;
    z-index: 999;
    left: 50%;
    top: 50%;
    position: absolute;
    height: 280px;
    transform: translate(-50%, -50%);
    background-color: #fff;

    &_title {
      height: 46px;
      line-height: 46px;
      border-bottom: 1px solid #1d7ecc;
      background-color: #1d7ecc;
      font-size: 16px;
      padding-left: 20px;
      margin: 0;
      color: #fff;
    }
    &_content {
      background: url('~@/assets/images/common/tip.png') no-repeat;
      padding-left: 100px;
      width: 280px;
      color: #e8661b;
      margin: 40px auto;
      font-size: 16px;
      min-height: 100px;
      text-align: left;
    }
    &_btn {
      text-align: center;
      &_item {
        border-radius: 3px;
        width: 120px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        display: inline-block;
        margin: 0 10px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
